import { Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { ResearchUnitsService } from '../research-units.service';
import { finalize, map, Observable, startWith } from 'rxjs';
import { AssetsUsage } from '../../shared/interfaces/assets-usage';
import { TranslateModule } from '@ngx-translate/core';
import { PortalMetricsComponent } from '../../portal/portal-metrics/portal-metrics.component';
import { AsyncPipe } from '@angular/common';
import { DeferLoadModule } from '@trademe/ng-defer-load';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

@Component({
    selector: 'esp-research-unit-metrics',
    templateUrl: './research-unit-metrics.component.html',
    styleUrls: ['./research-unit-metrics.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        DeferLoadModule,
        PortalMetricsComponent,
        AsyncPipe,
        TranslateModule
    ]
})
export class ResearchUnitMetricsComponent implements OnChanges {
    private unitsSvc = inject(ResearchUnitsService);

    readonly unitCode = input<string>(undefined);
    showMetricsTotals = false;
    loading = true;
    totalAssets$: Observable<{ name: string; value: number; icon: string }[]>;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.unitCode && changes.unitCode.currentValue) {
            this.totalAssets$ = this.unitsSvc
                .getOrgUnitMetrics(this.unitCode())
                .pipe(
                    startWith({ views: '0', downloads: '0', assetCount: '0' }),
                    map((_) => this.parseAssetMetrics(_)),
                    finalize(() => (this.loading = false)),
                );
        }
    }

    parseAssetMetrics = (data: AssetsUsage) => [
        {
            name: 'research.portal.metrics.total',
            value: data?.assetCount ? parseInt(data.assetCount) : 0,
            icon: 'database',
        },
        {
            name: 'research.portal.metrics.views',
            value: data?.views ? parseInt(data.views) : 0,
            icon: 'eye-outline',
        },
        {
            name: 'research.portal.metrics.downloads',
            value: data?.downloads ? parseInt(data.downloads) : 0,
            icon: 'cloud-download',
        },
    ];
}
